import React from 'react';
import PropTypes from 'prop-types';
import { useDeviceSize } from 'common/lib/hooks/useDeviceSize';
import * as S from './styles';
import { isAtLeastOneCadastreFieldValidForDisplay, shouldDisplayCadastreValue } from './cadastreHelper';

const CadastralInfo = ({
    municipalityNumber,
    sectionNumber,
    propertyUnitNumber,
    cadastralUnitNumber,
    leaseholdUnitNumber,
}) => {
    const { isMobile } = useDeviceSize();

    const info = (name, value) => {
        if (shouldDisplayCadastreValue(value)) {
            return (
                <div className="mb-8">
                    <p>{name}</p>
                    <p className="font-bold">{value}</p>
                </div>
            );
        }
        return null;
    };

    if (
        isAtLeastOneCadastreFieldValidForDisplay([
            municipalityNumber,
            sectionNumber,
            propertyUnitNumber,
            cadastralUnitNumber,
            leaseholdUnitNumber,
        ])
    ) {
        return (
            <div className="mt-32">
                <h4>Matrikkelinformasjon</h4>
                <S.Grid isMobile={isMobile}>
                    {info('Kommunenummer', municipalityNumber)}
                    {info('Gårdsnummer', cadastralUnitNumber)}
                    {info('Bruksnummer', propertyUnitNumber)}
                    {info('Festenummer', leaseholdUnitNumber)}
                    {info('Seksjonsnummer', sectionNumber)}
                </S.Grid>
            </div>
        );
    }
    return null;
};

CadastralInfo.propTypes = {
    municipalityNumber: PropTypes.string,
    sectionNumber: PropTypes.string,
    propertyUnitNumber: PropTypes.string,
    cadastralUnitNumber: PropTypes.string,
    leaseholdUnitNumber: PropTypes.string,
};

export default CadastralInfo;
